module.exports = __webpack_public_path__ + "static/media/home.e4b18a2d.svg";